<template>
  <div>
    <div class="wrap">

    </div><button @click="clearData">清除缓存</button>
    <div>
      {{user}}
    </div>


  </div>
</template>
<script>
import loginService from '../plugin/extendFn/loginService';
  export default {
    data() {
      return {
        user:'',
      }
    },
    props: {},
    methods: {
      clearData(){
        localStorage.clear();
        loginService.logout();
        alert('已清除');
      }
    },
    computed: {},
    async mounted() {
      this.user = await loginService.getLoginUser()||'没有数据';
    }
  }
</script>
<style scoped lang="scss">
  .wrap{
    padding-top: 3rem;
  }
  button{
    width: 4rem;
    height: 4rem;
    color: #ffffff;
    background:#000000;
    border-radius: 50%;
    outline: none;
    font-size: .32rem;
    display: block;
    margin: auto auto;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/clear.vue